module.exports = __webpack_public_path__ + "static/media/img-quality-control.4546dc96.png";